module.exports = __webpack_public_path__ + "img/calling.c25e4fc6.svg";